// NEW_FILE_JUSTIFIED: Reducer for GmailPage state management — extracted to keep GmailPage.tsx under 200-line component limit
import { useReducer } from 'react';
import { useLocation } from 'react-router-dom';
import type { IGmailPageState, TGmailPageAction } from '@/@types/gmail';

export const PAGE_SIZE = 50;

function gmailPageReducer(state: IGmailPageState, action: TGmailPageAction): IGmailPageState {
  switch (action.type) {
    case 'SET_TAB':
      return {
        ...state,
        activeTab: action.payload,
        page: 0,
        selectedIds: new Set(),
        selectedThreadId: null,
      };
    case 'SET_SEARCH':
      return { ...state, searchQuery: action.payload, page: 0 };
    case 'SET_PAGE':
      return { ...state, page: action.payload, selectedIds: new Set() };
    case 'SET_SELECTED_IDS':
      return { ...state, selectedIds: action.payload };
    case 'SET_THREAD':
      return { ...state, selectedThreadId: action.payload, isComposing: false };
    case 'SET_COMPOSING':
      return {
        ...state,
        isComposing: action.payload,
        selectedThreadId: null,
        replyContext: null,
        replyThreadId: null,
        replyInReplyTo: null,
      };
    case 'SET_REPLY':
      return {
        ...state,
        isComposing: true,
        selectedThreadId: null,
        replyContext: action.payload.data,
        replyThreadId: action.payload.threadId,
        replyInReplyTo: action.payload.inReplyTo,
      };
    default: {
      const _exhaustive: never = action;
      return _exhaustive;
    }
  }
}

export function useGmailPageReducer() {
  const location = useLocation();
  const isComposePath = location.pathname === '/messages/gmail/compose';
  const searchParams = new URLSearchParams(location.search);
  const toParam = searchParams.get('to');

  const init: IGmailPageState = {
    activeTab: 'inbox',
    searchQuery: '',
    page: 0,
    selectedIds: new Set(),
    selectedThreadId: null,
    isComposing: isComposePath,
    replyContext: isComposePath && toParam ? { to: [toParam], subject: '' } : null,
    replyThreadId: null,
    replyInReplyTo: null,
  };

  return useReducer(gmailPageReducer, init);
}
